import tinycolor from 'tinycolor2';

export const getHoverColor = (hexColor: string) => {
  const color = tinycolor(hexColor).setAlpha(0.7);
  const rgba = color.toRgbString();

  return rgba;
};
